import React from "react";
import AssignmentSectionCard from "./AssignmentSectionCard";

export default function Back9Card(props) {
  return (
    <AssignmentSectionCard
      {...props}
      rowDragType="application/x-back9-extra-row"
    />
  );
}